import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Avatar,
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  Tooltip,
} from '@mui/material';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Modal } from '../../../../components';
import ActionsList from '../../../../components/ActionsList';
import LoadingComponent from '../../../../components/Loading';
import { CYAN_COLOR, MORADO_COLOR } from '../../../../constants/ColorsConst';
import { SU } from '../../../../constants/ConfigConst';
import * as CONST from '../../../../constants/FieldsConst';
import { downloadExcelFile } from '../../../../helpers/exportHelper';
import { useNotification } from '../../../../helpers/notification';
import * as ROUTES from '../../../../router/Routes';
import { textLabelsTable } from '../../../invitados/components/ListadoInvitados';
import { isManagerUserCode } from '../../../modulos/modules.helpers';
import { NameComponent } from '../../../usuarios/components/ListadoUsuarios';
import {
  deleteServiciosAction,
  getAllServiciosAction,
  saveServiciosAction,
  setActivoServiciosAction,
} from '../ServiciosAction';
import { PARAMS_SERVICIOS } from '../ServiciosReducer';
import { serviciosApi } from '../ServiciosService';
import ExpandeRowServicios from './ExpandedRowServicios';

const ListadoServicios = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { addNotification } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const serviciosStore = Redux.useSelector((state) => state.servicios);
  const loginStore = Redux.useSelector((state) => state.login);

  const isRoot = loginStore.user.roles.some((r) => r.name === SU);
  const isManager =
    !isRoot &&
    isManagerUserCode(loginStore.user.userCodes, entidadesStore.activo?.id);

  const payload = {
    ...serviciosStore.params,
  };

  React.useEffect(() => {
    async function fetchData() {
      dispatch({ type: PARAMS_SERVICIOS, payload });
      if (serviciosStore.all && serviciosStore.all.length === 0) {
        await getAllServiciosAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [rows, setRows] = React.useState([]);
  const [loadingDelete, setLoadingDelete] = React.useState(false);

  const _handleInfoClick = async (id) => {
    const res = serviciosStore.all.find((el) => el.id === id);
    await setActivoServiciosAction(dispatch, res);
    setOpenModalForm(true);
  };

  const _handleEditClick = async (id) => {
    const res = serviciosStore.all.find((el) => el.id === id);
    await setActivoServiciosAction(dispatch, res);
    setOpenModalForm(true);
  };

  const [isDelete, setIsDelete] = React.useState(false);
  const [isToggleActive, setIsToggleActive] = React.useState(false);
  const _handleDeleteClick = async (id) => {
    setLoadingDelete(true);
    await deleteServiciosAction(
      { dispatch, addNotification },
      id,
      serviciosStore.params
    );
    setIsDelete(false);
    setLoadingDelete(false);
  };

  const _handleToggleActiveClick = async (id) => {
    setLoadingDelete(true);
    await saveServiciosAction(
      { dispatch, addNotification },
      id,
      {
        active: !serviciosStore.activo.active,
      },
      serviciosStore.params
    );
    setIsToggleActive(false);
    setLoadingDelete(false);
  };

  React.useEffect(() => {
    setRows([]);
    serviciosStore.all.forEach((el) => {
      setRows((old) => [
        ...old,
        {
          ...el,
          [CONST.CLASS_TYPE_ID]: el.type?.name ?? 'N/A',
          [CONST.CLASS_CATEGORY_ID]: el.category?.name ?? 'N/A',
          active: el.active ? 'Activo' : 'Bloqueado',
          date: `${moment(el.startDate).format('DD-MM-YYYY')} - ${moment(
            el.endDate
          ).format('DD-MM-YYYY')}`,
          actions: el,
        },
      ]);
    });
  }, [serviciosStore.all]);

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.IMAGE_URL,
      label: 'Imagen',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar alt={value} sx={{ width: 30, height: 30 }} src={value} />
          );
        },
      },
    },
    {
      name: CONST.NAME,
      label: 'Nombre',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleInfoClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    // {
    //   name: 'date',
    //   label: 'Fecha',
    //   options: {
    //     filter: true,
    //     sort: true,
    //   },
    // },
    {
      name: CONST.CLASS_TYPE_ID,
      label: 'Tipo',
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: CONST.CLASS_CATEGORY_ID,
    //   label: 'Categoría',
    //   options: {
    //     filter: true,
    //     sort: true,
    //   },
    // },
    {
      name: CONST.ACTIVE,
      label: 'Estatus',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                sx={{
                  backgroundColor:
                    value === 'Activo' ? CYAN_COLOR : MORADO_COLOR,
                  color: 'white',
                }}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.ACTIONS,
      label: 'Acción',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box align="left" sx={{ display: 'flex', flexDirection: 'row' }}>
                <Tooltip title="Información">
                  <IconButton
                    aria-label="edit"
                    size="small"
                    color="primary"
                    onClick={() => _handleInfoClick(tableMeta.rowData[0])}
                  >
                    <VisibilityIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
                {!isManager && (
                  <ActionsList
                    id={tableMeta.rowData[0]}
                    onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                    onDelete={async () => {
                      await setActivoServiciosAction(dispatch, value);
                      setIsDelete(true);
                    }}
                    onToggleActive={async () => {
                      await setActivoServiciosAction(dispatch, value);
                      setIsToggleActive(true);
                    }}
                    active={value.active}
                  />
                )}
              </Box>
            </>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return (
        <ExpandeRowServicios
          data={serviciosStore.all.find((el) => el.id === rowData[0])}
          length={rowData.length}
        />
      );
    },

    onDownload: () => {
      const url = `${serviciosApi}/export`;
      const name = 'servicios';
      const params = payload;
      downloadExcelFile(url, params, name, addNotification);
      return false;
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels: textLabelsTable,
  };

  return (
    <Grid container>
      <LoadingComponent
        isLoading={serviciosStore.loadingGetAll || loadingDelete}
        text="Cargando lista..."
      />
      <Grid item md={12}>
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {serviciosStore.activo ? (
        <Modal
          id="modalEliminarArea"
          title={`Eliminar ${serviciosStore.activo.name}`}
          open={isDelete}
          maxWidth="sm"
          onClose={() => setIsDelete(!isDelete)}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              ¿Seguro que quieres eliminar esta área?
              <p>
                <strong>{serviciosStore.activo.name}</strong>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={async () => {
                await _handleDeleteClick(serviciosStore.activo.id);
              }}
            >
              ELIMINAR
            </Button>
            <Button
              sx={{ color: MORADO_COLOR }}
              onClick={() => setIsDelete(false)}
            >
              CANCELAR
            </Button>
          </DialogActions>
        </Modal>
      ) : null}

      {serviciosStore.activo ? (
        <Modal
          id="modalToggleActivo"
          title={`${serviciosStore.activo.active ? 'Bloquear' : 'Activar'} ${
            serviciosStore.activo.name
          }`}
          open={isToggleActive}
          maxWidth="sm"
          onClose={() => setIsToggleActive(!isToggleActive)}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {`¿Seguro que quieres ${
                serviciosStore.activo.active ? 'Bloquear' : 'Activar'
              } esta área?`}
              <p>
                <strong>{serviciosStore.activo.name}</strong>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={async () => {
                await _handleToggleActiveClick(serviciosStore.activo.id);
              }}
            >
              ACEPTAR
            </Button>
            <Button
              sx={{ color: MORADO_COLOR }}
              onClick={() => setIsToggleActive(false)}
            >
              CANCELAR
            </Button>
          </DialogActions>
        </Modal>
      ) : null}
    </Grid>
  );
};

export default ListadoServicios;
